export default "__VITE_ASSET__BQcAh5Re__"